/* Hairy Housemates :: Core Web Vitals self-report. Emits web_vital events via HH.events.track. No external deps. */
/* Cycle 6 of advance-everywhere-v6. Thresholds (Google web-vitals):
   LCP 2500/4000, CLS 0.1/0.25, INP 200/500, FCP 1800/3000, TTFB 800/1800.
   FCP+TTFB emit immediately; LCP+CLS+INP emit on hide. Debug: ?hhdebug=1. */
(function () {
  'use strict';
  var w = window;
  if (!w.PerformanceObserver) return;
  w.HH = w.HH || {};
  if (w.HH._vitalsInit) return;
  w.HH._vitalsInit = true;

  var debugOn = false;
  try { debugOn = new URLSearchParams(w.location.search).get('hhdebug') === '1'; } catch (_e) {}

  var pending = [];
  function flush() {
    var bus = w.HH.events && w.HH.events.track;
    if (!bus || !pending.length) return;
    var items = pending.splice(0);
    items.forEach(function (p) { try { bus('web_vital', p); } catch (_e) {} });
  }
  function uid() { return Math.random().toString(36).slice(2); }

  function rate(n, v) {
    if (v == null || !isFinite(v)) return 'good';
    var t = { LCP: [2500, 4000], CLS: [0.1, 0.25], INP: [200, 500], FCP: [1800, 3000], TTFB: [800, 1800] }[n];
    if (!t) return 'good';
    return v <= t[0] ? 'good' : (v <= t[1] ? 'needs-improvement' : 'poor');
  }

  function emit(name, value, extras) {
    var v = (typeof value === 'number' && isFinite(value)) ? value : 0;
    var p = { name: name, value: v, rating: rate(name, v) };
    if (extras) for (var k in extras) if (Object.prototype.hasOwnProperty.call(extras, k)) p[k] = extras[k];
    if (debugOn) { try { console.debug('[hh:vital]', name, v, p.rating); } catch (_e) {} }
    var bus = w.HH.events && w.HH.events.track;
    if (bus) { try { bus('web_vital', p); } catch (_e) {} }
    else { pending.push(p); setTimeout(flush, 0); }
  }

  function obs(opts, cb) {
    try { var po = new PerformanceObserver(cb); po.observe(opts); return po; }
    catch (_e) { return null; }
  }

  // TTFB :: read navigation timing once.
  try {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav) emit('TTFB', Math.max(0, (nav.responseStart || 0) - (nav.activationStart || 0)), { id: uid() });
  } catch (_e) {}

  // FCP :: emit on first paint entry.
  var fcpDone = false;
  obs({ type: 'paint', buffered: true }, function (list) {
    list.getEntries().forEach(function (e) {
      if (e.name === 'first-contentful-paint' && !fcpDone) { fcpDone = true; emit('FCP', e.startTime, { id: uid() }); }
    });
  });

  // LCP :: track latest, emit on hide.
  var lcpVal = 0, lcpId = uid(), lcpEl = '';
  var lcpObs = obs({ type: 'largest-contentful-paint', buffered: true }, function (list) {
    var es = list.getEntries(), last = es[es.length - 1];
    if (!last) return;
    lcpVal = last.renderTime || last.startTime || 0;
    if (last.element && last.element.tagName) lcpEl = last.element.tagName.toLowerCase();
  });

  // CLS :: session-window aggregate (1s gap, 5s max), keep largest window.
  var clsVal = 0, clsId = uid(), clsCount = 0;
  var sessVal = 0, sessEntries = [];
  var clsObs = obs({ type: 'layout-shift', buffered: true }, function (list) {
    list.getEntries().forEach(function (e) {
      if (e.hadRecentInput) return;
      var first = sessEntries[0], last = sessEntries[sessEntries.length - 1];
      if (sessEntries.length && (e.startTime - last.startTime > 1000 || e.startTime - first.startTime > 5000)) {
        sessVal = e.value; sessEntries = [e];
      } else { sessVal += e.value; sessEntries.push(e); }
      if (sessVal > clsVal) { clsVal = sessVal; clsCount = sessEntries.length; }
    });
  });

  // INP :: max event duration where interactionId > 0 (Chrome only; others no-op).
  var inpVal = 0, inpId = uid();
  var inpObs = obs({ type: 'event', buffered: true, durationThreshold: 16 }, function (list) {
    list.getEntries().forEach(function (e) {
      if (e.interactionId && e.interactionId > 0 && e.duration > inpVal) inpVal = e.duration;
    });
  });

  // Final emit on hide.
  var done = false;
  function finalize() {
    if (done) return;
    done = true;
    [lcpObs, clsObs, inpObs].forEach(function (o) { try { if (o && o.takeRecords) o.takeRecords(); } catch (_e) {} });
    if (lcpVal) emit('LCP', lcpVal, { id: lcpId, element: lcpEl });
    emit('CLS', Number(clsVal.toFixed(4)), { id: clsId, count: clsCount });
    if (inpVal) emit('INP', inpVal, { id: inpId });
    [lcpObs, clsObs, inpObs].forEach(function (o) { try { if (o) o.disconnect(); } catch (_e) {} });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') finalize();
  }, { capture: true });
  w.addEventListener('pagehide', finalize, { capture: true });

  // ---------- Cycle 6 polish :: opt-in visible vitals badge ----------
  // Renders only when URL has ?hhdebug=1. Pure surface; zero cost when absent.
  try {
    var debugOn = (new URLSearchParams(location.search).get('hhdebug') === '1');
    if (debugOn && !document.getElementById('hh-vitals-badge')) {
      var box = document.createElement('div');
      box.id = 'hh-vitals-badge';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      box.setAttribute('aria-label', 'Web vitals');
      ['LCP','CLS','INP','FCP','TTFB'].forEach(function (n) {
        var row = document.createElement('span');
        row.setAttribute('data-vital', n);
        var label = document.createElement('b');
        label.textContent = n;
        var val = document.createElement('span');
        val.className = 'v';
        val.textContent = '--';
        row.appendChild(label);
        row.appendChild(document.createTextNode(' '));
        row.appendChild(val);
        box.appendChild(row);
      });
      var s = document.createElement('style');
      s.textContent = '#hh-vitals-badge{position:fixed;left:12px;bottom:12px;z-index:97;display:flex;gap:10px;flex-wrap:wrap;max-width:calc(100vw - 24px);padding:8px 12px;font:11px/1.2 ui-monospace,SFMono-Regular,Menlo,monospace;color:var(--c-fg,#1a1814);background:var(--c-bg,#faf6ec);border:1px solid var(--c-border,rgba(0,0,0,.12));border-radius:10px;box-shadow:0 6px 18px rgba(0,0,0,.08);pointer-events:none}#hh-vitals-badge b{letter-spacing:.06em;opacity:.72;margin-right:4px}#hh-vitals-badge span.v{font-variant-numeric:tabular-nums}#hh-vitals-badge .good{color:#27ae60}#hh-vitals-badge .poor{color:#b8452c}@media (max-width:480px){#hh-vitals-badge{font-size:10px;gap:6px;padding:6px 8px}}';
      document.head.appendChild(s);
      (document.body || document.documentElement).appendChild(box);

      function ratingClass(name, v) {
        var t = { LCP: [2500, 4000], CLS: [0.1, 0.25], INP: [200, 500], FCP: [1800, 3000], TTFB: [800, 1800] }[name];
        if (!t) return 'v';
        return v <= t[0] ? 'v good' : (v <= t[1] ? 'v' : 'v poor');
      }
      function fmt(name, v) {
        if (name === 'CLS') return v.toFixed(3);
        return Math.round(v).toString() + 'ms';
      }
      document.addEventListener('hh:event', function (e) {
        if (!e || !e.detail || e.detail.name !== 'web_vital') return;
        var p = e.detail.props || {};
        var name = p.name;
        var v = p.value;
        if (typeof v !== 'number') return;
        var row = box.querySelector('[data-vital="' + name + '"] .v');
        if (!row) return;
        row.textContent = fmt(name, v);
        row.className = ratingClass(name, v);
      });
    }
  } catch (_e) {}
})();
